<template>
  <!-- 电池包-电池list-->
  <div class="batteryOuter">
    <div class="batteryCom">
      <div
        class="margin-top-sm batteryBagOuter"
        v-for="(item, index) in batteryBagList"
        :key="index"
        :class="index==curIndex?'select':''"
        @click="clickIndex(item,index)"
      >
        <div
          class="point"
          v-if="(index==curIndex)&&(item.st>=65||item.sv>=4)"
        >
          <div class="inner flex align-center flex-direction">
            <!-- <div class="close pointer"></div> -->
            <div class="title text-xsss margin-top-13 padding-bottom-8">当前编号:#{{index | formatterNum}}</div>
            <div class="title text-12 padding-bottom-8">当前电压:{{item.sv||''}}</div>
            <div class="code text-12">当前温度:{{item.st||''}}</div>
          </div>
        </div>
        <div
          class="battery-color flex flex-direction justify-center"
          :class="{'battery-red':item.st>=65&&item.sv>=4,'battery-redTem':item.st>=65&&item.sv<4,'battery-redVol':item.sv>=4&&item.st<65}"
        >
          <div class="text-14 margin-left-15">
            #{{index | formatterNum}}
          </div>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
import { dataInterface } from "@/api/dataInterfaceApi";
export default {
  data() {
    return {
      batteryHolder: [],
      curIndex: 0, //当前选中电池下标,定义新的变量，防止修改父组件
      batteryBagList: [],
    };
  },
  components: {},
  props: {
    selectBattery: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    selectBattery(newValue, oldValue) {
      console.log(newValue, "newValue");
      this.curSingleIndex = newValue;
    },
  },
  mounted() {},
  methods: {
    getData(data) {
      this.getBatteryPackageInfo(data);
    },
    // 点击单个电池
    clickIndex(item, index) {
      if (index != this.curIndex) {
        this.curIndex = index;
        this.$EventBus.$emit('changeTem',{'index':index});
      }
    },
    getBatteryPackageInfo(data) {
      let _this = this;
      dataInterface
        .dataFaceApi({
          enCode: "TiDB-dianchixiang-dianchidantixinxi",
          "@battery_id": data.batteryId,
        })
        .then((res) => {
          if (!res) return;
          res = res[0];
          let newList = [];
          console.log("中间电池单体", res);
          let st = res.st.split("|");
          let stList = st.slice(2, st.length);
          let sv = res.sv.split("|");
          let scList = sv.slice(2, sv.length);
          this.batteryBagList = [...scList].map((item, index) => {
            return {
              sv: item,
              st: parseFloat(stList[index]).toFixed(2)||0,
            };
          });

          console.log(" this.batteryBagList", this.batteryBagList);
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  filters: {
    // 格式化数据
    formatterNum(data) {
      return data < 9 ? "0" + (data + 1) : data + 1;
    },
  },
};
</script>
<style lang="scss" scoped>
.batteryBagOuter {
  position: relative;
  cursor: pointer;
  .point {
    display: none;
  }
  &.select {
    .batteryImg {
      background: url("~@/assets/images/battery/battery_box_select.png");
      background-size: 100% 100%;
    }
    .point {
      display: block;
      position: fixed;
      width: 184px;
      height: 91px;
      // background-color: #3dbcc1;
      background-image: url("~@/assets/images/batteryBag/bg.png");
      background-size: cover;
      bottom: 33%;
      left: 28%;
      z-index: 100;
      .inner {
        position: relative;
        width: 184px;
        height: 91px;
        .close{
          position: absolute;
          width: 22px;
          height: 22px;
          background-image: url("~@/assets/images/batteryBag/close.png");
          background-size: cover;
          top: 10px;
          right: 10px;
        }
        .title {
          // border-bottom: 1px solid #3dbcc1;
        }
      }
    }
  }
}
.batteryOuter {
  margin-top: 10%;
  height: 300px;
  overflow-y: scroll;
}
.batteryCom {
  display: grid;
  grid-template-columns: repeat(10, 81px);
  grid-template-rows: repeat(3, 40px);
  grid-row-gap: 29px;
  grid-column-gap: 7px;
  justify-content: center;
}
.battery-color {
  // 单体：默认正常
  width: 81px;
  height: 40px;
  background: url("~@/assets/images/batteryBag/battery_norm.png") no-repeat;
  background-size: 100% 100%;
  position: relative;
  &.battery-red {
    //电压，温度均不正常
    background: url("~@/assets/images/batteryBag/battery_error2.png") no-repeat;
    background-size: 100% 100%;
  }
  &.battery-redTem {
    //温度，不正常
    background: url("~@/assets/images/batteryBag/battery_error1.png") no-repeat;
    background-size: 100% 100%;
  }
  &.battery-redVol {
    //电压，不正常
    background: url("~@/assets/images/batteryBag/battery_error.png") no-repeat;
    background-size: 100% 100%;
  }
}
</style>
